import { TypedDocumentNode, gql } from "@apollo/client";

export interface Countries {
  countries: {
    id: string;
    name: string;
    code_slug: string;
  }[];
}

export const GET_COUNTRIES: TypedDocumentNode<Countries> = gql`
  query GetCountries {
    countries {
      id
      name
      code_slug
    }
  }
`;
